import { Component } from 'react';
import AMS from '@ui/components/ams';
import { pushPageViewEvent } from '@lib/atm';
import Page from '@ui/components/ams/Pages/Page';
import { withServerSideProps } from '@lib/withServerSideProps';
import { helpPageQuery } from '@queries/pages/help';

const PAGE_NAME = 'help';

class HelpPage extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData
    } = this.props;

    const {
      pageTitle: title,
    } = pageData.helpPage || {};

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        title,
        sections: [PAGE_NAME],
      },
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
    } = this.props;

    const {
      helpPage = {},
    } = pageData;

    const {
      pageTitle,
      displayName,
      metaDescription,
    } = helpPage;

    return (
      <Page
        analyticsPageName={PAGE_NAME}
        pageTitle={pageTitle}
        metaDescription={metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.HelpPageContent
          displayName={displayName}
          helpPageData={helpPage}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: helpPageQuery,
});

export default HelpPage;
